// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__NfqxR","filesListContainer":"PosDisputesFiles_filesListContainer__31f-r","filesButton":"PosDisputesFiles_filesButton__3dPwf"};